<template>
  <div class="BuyerItemContainer">
    <nut-row class="bothCenter">
      <nut-col :span="20" class="leftCenter">
        <img :src="data.avatar"
               class="sqr52 brd30"/>
        <nut-row class="colFlex ml8">
          <span class="ft16">{{ data.name }}</span>
          <span class="ft14 lightText">下单时间：{{ data.time }}</span>
        </nut-row>
      </nut-col>
      <nut-col :span="4" class="rightCenter ft14">
        <span>第</span>
        <span class="numberText">{{ data.index }}</span>
        <span>位</span>
      </nut-col>
    </nut-row>
  </div>
</template>

<script>
export default {
  name: "BuyerItem",
  props: {
    data: {
      type: Object,
      default: ()=>{
        return {
          avatar:'https://cdn.waityou.online/7dae4c32-9c89-4ad6-22dc-2edfaeae5420.png',
          name:'',
          time:null,
          index:0,
        }
      }
    },
  },
  methods: {
    init() {

    }
  },
  mounted() {
    this.init()
  }
}
</script>

<style lang="scss" scoped>
.BuyerItemContainer {
  display: flex;
  flex-direction: column;
  background-color: white;
  padding: 16px;
}
</style>